/**
 * UNAUTHORIZED COMPONENT
 * ======================
 *
 * Page affichée lorsqu'un utilisateur authentifié tente d'accéder
 * à un environnement sans avoir les permissions nécessaires.
 *
 * Fonctionnalités:
 * - Message d'erreur clair
 * - Affichage de l'email utilisé
 * - Bouton de déconnexion
 * - Informations de contact support
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, authState, signOut } from '@angular/fire/auth';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.css'],
    standalone: true,
    imports: []
})
export class UnauthorizedComponent implements OnInit {

  userEmail: string = '';

  constructor(
    private auth: Auth,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Récupérer l'email de l'utilisateur actuel
    authState(this.auth).subscribe(user => {
      if (user?.email) {
        this.userEmail = user.email;
      }
    });
  }

  /**
   * Déconnecter l'utilisateur et rediriger vers login
   */
  async logout(): Promise<void> {
    try {
      await signOut(this.auth);
      console.log('✅ Déconnexion réussie');
      this.router.navigate(['/team-login']);
    } catch (error) {
      console.error('❌ Erreur lors de la déconnexion:', error);
    }
  }
}
